import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=660211f8&scoped=true"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"
import style0 from "./BaseForm.vue?vue&type=style&index=0&id=660211f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660211f8",
  null
  
)

export default component.exports